import './radioButton.scss';
import {Paragraph} from "../../Elements/Paragraph";
import {useTranslation} from "react-i18next";
import type { RadioButton_Text_Props } from "./RadioButton.interface";

/**
 * Primary UI component for user interaction
 */
export function TextRadioButton (props: RadioButton_Text_Props) {
    
    const {t} = useTranslation();
    
    return (
        <div className={["radiobutton-wrapper", props.className, props.hide ? "hide" : "", props.recommended ? "highlight" : "no-highlight"].join(" ")}>
            {props.recommended &&
            <div className={"recommended"} onClick={props.onClick}>
                {t("button.recommended")}
            </div>
            }
            <div className="radiobutton-input-row" onClick={props.onClick}>
                <div className="input">
                    <input id={props.id} aria-label={props.id} type="radio" readOnly
                           checked={props.selected}/>
                </div>
                <div>
                    <label htmlFor={props.id} aria-label={props.id}>
                        {props.label}
                    </label>
                </div>
            </div>
            {
                props.selected &&
                <div className="radiobutton-content-row">
                    <div className="text">
                        <Paragraph text={props.text ? props.text : ""}/>
                    </div>
                </div>
            }
        </div>
    );
}